// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1QRua","colMin":"styles_colMin__3tfWn","colCheckbox":"styles_colCheckbox__3B7Kx"};